import React from "react";
import { dateFormatter } from "../../../components/tables/table";

const ProductUnitTypeContent = ({ productUnitType }) => {
	if (!productUnitType) return <></>;
	return (
		<>
			<div className="row d-flex align-items-center">
				<div className="col-12">
					<h5>Descripción</h5>
					<p>{productUnitType?.descripcion}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col">
					<h5>Fecha Alta</h5>
					<p>{dateFormatter(productUnitType?.fecha_alta) + "h"}</p>
				</div>
			</div>
		</>
	);
};

export default ProductUnitTypeContent;
